import { appConstantSettings } from 'srcReact/appConstantSettings'
import { commonFeedConstants as fc } from 'srcReact/components/common2/FeedsTabContent/constants'
import { feedService, generalService } from 'srcReact/services'
import { getLinksFromMessage, getParsedMessage, getTaggedUserIds } from 'srcReact/helpers/feedHelper'

const PAGINATION_QUANTITY = appConstantSettings.PAGINATION_QUANTITY

export const commonFeedActions = {
  getFeeds,
  postFeed,
  editFeed,
  deleteFeed,
  addReactionToMessage,
  deleteReactionFromMessage,
  setSelectedNewsFeed,
  deleteFileFromMessage,
  pinMessageToTop,
  unpinMessageFromTop,
  saveDraftToState,
  addDraftNewsFeed,
  translateMessage,
  getFeedBlock,
  locatePostInNewsFeed,
  createBackgroundTag,
  removeProcessedtag,
  setOriginMessageId,
  updateTagCount,
  getSharingTagFiles,
  removeSharingProcessedTagFiles,
  setPendingMessageCount
}

function setSelectedNewsFeed(newsFeed) {
  return { type: fc.SELECTED_NEWSFEED, newsFeed }
}

// we are storing newsfeedId and count in reducer to be used in file preview (file modal popup)
function setPendingMessageCount(newsFeedId, count) {
  return { type: fc.SET_PENDING_MESSAGE_COUNT, newsFeedId, count }
}
function setOriginMessageId(originMessageId) {
  return { type: fc.SET_ORIGIN_MESSAGE_ID, originMessageId }
}
function updateTagCount() {
  return { type: fc.UPDATE_TAG_COUNT }
}

function getFeeds(
  objectType,
  objectId,
  pagination,
  isNewContent = false,
  workplaceIds = '',
  scope = '',
  quantity = PAGINATION_QUANTITY
) {
  const { nextOffset, isPagination } = pagination
  return (dispatch) => {
    dispatch(request(objectType, objectId, isPagination, isNewContent))

    feedService.getNewsFeed(objectType, objectId, nextOffset, quantity, workplaceIds, scope).then(
      (response) => {
        dispatch(success(response, objectId, workplaceIds))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(objectType, objectId, isPagination, isNewContent) {
    return { type: fc.GET_FEEDS_REQUEST, response: { objectType, objectId, isPagination, isNewContent } }
  }
  function success(response, objectId, workplaceIds) {
    const updatedResponse = { ...response, isPagination, objectId, workplaceIds, isNewContent }
    return { type: fc.GET_FEEDS_SUCCESS, updatedResponse }
  }
  function failure(error) {
    return { type: fc.GET_FEEDS_FAILURE, error }
  }
}

function postFeed(newsfeedId, message, originMessageId, fileIds, quantity, organizationId, workplaceIds, hasFiles) {
  const parsedMessage = getParsedMessage(message)
  const taggedUserIds = getTaggedUserIds(parsedMessage)
  const containedLinks = getLinksFromMessage(parsedMessage)
  return (dispatch) => {
    dispatch(request({ newsfeedId, message, originMessageId, fileIds }))

    feedService
      .postNewFeed(
        newsfeedId,
        message,
        originMessageId,
        fileIds,
        taggedUserIds,
        containedLinks,
        quantity,
        organizationId,
        workplaceIds
      )
      .then(
        (response) => {
          dispatch(commonFeedActions.addDraftNewsFeed(newsfeedId, originMessageId || 0))
          response['draftMessageFeedId'] = originMessageId || 0
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(response) {
    return { type: fc.POST_MESSAGE_REQUEST, response: { ...response, originMessageId, hasFiles } }
  }
  function success(response) {
    return { type: fc.POST_MESSAGE_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.POST_MESSAGE_FAILURE, error }
  }
}

function addReactionToMessage(messageId, reactionCode, quantity, organizationId, workplaceIds) {
  return (dispatch) => {
    dispatch(request({ messageId, reactionCode }))

    feedService.addReactionToMessage(messageId, reactionCode, quantity, organizationId, workplaceIds).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.ADD_REACTION_REQUEST, response }
  }
  function success(response) {
    return { type: fc.ADD_REACTION_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.ADD_REACTION_FAILURE, error }
  }
}

function deleteReactionFromMessage(reactionId, reactionCode, messageId, quantity, organizationId, workplaceIds) {
  return (dispatch) => {
    dispatch(request({ reactionId, reactionCode, messageId }))

    feedService.deleteReactionFromMessage(reactionId, quantity, organizationId, workplaceIds).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.DELETE_REACTION_REQUEST, response }
  }
  function success(response) {
    return { type: fc.DELETE_REACTION_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.DELETE_REACTION_FAILURE, error }
  }
}

function deleteFeed(messageId, quantity, organizationId, workplaceIds) {
  return (dispatch) => {
    dispatch(request({ messageId }))

    feedService.deleteFeed(messageId, quantity, organizationId, workplaceIds).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.DELETE_MESSAGE_REQUEST, response }
  }
  function success(response) {
    return { type: fc.DELETE_MESSAGE_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.DELETE_MESSAGE_FAILURE, error }
  }
}

function editFeed(feedId, message, quantity, organizationId, workplaceIds) {
  const parsedMessage = getParsedMessage(message)
  const taggedUserIds = getTaggedUserIds(parsedMessage)
  const containedLinks = getLinksFromMessage(parsedMessage)
  return (dispatch) => {
    dispatch(request({ feedId, message }))

    feedService.editFeed(feedId, message, taggedUserIds, containedLinks, quantity, organizationId, workplaceIds).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.EDIT_MESSAGE_REQUEST, response, feedId }
  }
  function success(response) {
    return { type: fc.EDIT_MESSAGE_SUCCESS, response, feedId }
  }
  function failure(error) {
    return { type: fc.EDIT_MESSAGE_FAILURE, error, feedId }
  }
}

function deleteFileFromMessage(messageId, fileId, quantity, organizationId, workplaceIds) {
  return (dispatch) => {
    dispatch(request(messageId, fileId))

    feedService.deleteFileFromFeed(messageId, fileId, quantity, organizationId, workplaceIds).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(messageId, fileId) {
    return { type: fc.DELETE_FILE_FROM_MESSAGE_REQUEST, response: { messageId, fileId } }
  }
  function success(response) {
    const updatedResponse = { messageId, ...response }
    return { type: fc.DELETE_FILE_FROM_MESSAGE_SUCCESS, updatedResponse }
  }
  function failure(error) {
    return { type: fc.DELETE_FILE_FROM_MESSAGE_FAILURE, error }
  }
}

function pinMessageToTop(messageId, quantity) {
  return (dispatch) => {
    dispatch(request({ messageId }))

    feedService.pinMessageToTop(messageId, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.PIN_MESSAGE_REQUEST, response }
  }
  function success(response) {
    return { type: fc.PIN_MESSAGE_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.PIN_MESSAGE_FAILURE, error }
  }
}

function unpinMessageFromTop(messageId, quantity) {
  return (dispatch) => {
    dispatch(request({ messageId }))

    feedService.unpinMessageFromTop(messageId, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.UNPIN_MESSAGE_REQUEST, response }
  }
  function success(response) {
    return { type: fc.UNPIN_MESSAGE_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.UNPIN_MESSAGE_FAILURE, error }
  }
}

function saveDraftToState(draftMessage, draftFeedId, draftMessageFeedId) {
  return { type: fc.SAVE_DRAFT_TO_STATE, draftMessage, draftFeedId, draftMessageFeedId }
}

function addDraftNewsFeed(newsfeed_id, origin_message_id, message = '', file_ids) {
  return (dispatch) => {
    dispatch(request({ newsfeed_id, origin_message_id, message, file_ids }))

    feedService.saveDraftNewsFeed(newsfeed_id, origin_message_id, message, file_ids).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: fc.ADD_DRAFT_NEWSFEED_REQUEST, data }
  }
  function success(data) {
    return { type: fc.ADD_DRAFT_NEWSFEED_SUCCESS, data }
  }
  function failure(error) {
    return { type: fc.ADD_DRAFT_NEWSFEED_FAILURE, error }
  }
}

function translateMessage(organizationId, messageId, originalText, langaugeTarget) {
  return (dispatch) => {
    dispatch(request({ organizationId, messageId, originalText, langaugeTarget }))

    generalService.translateMessage(organizationId, messageId, originalText, langaugeTarget).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.TRANSLATE_MESSAGE_REQUEST, response }
  }
  function success(response) {
    return { type: fc.TRANSLATE_MESSAGE_SUCCESS, response, messageId }
  }
  function failure(error) {
    return { type: fc.TRANSLATE_MESSAGE_FAILURE, error }
  }
}

function saveDraftNewsFeed(newsfeed_id, origin_message_id, message = '', file_ids) {
  return (dispatch) => {
    dispatch(request({ newsfeed_id, origin_message_id, message, file_ids }))

    generalService.saveDraftNewsFeed(newsfeed_id, origin_message_id, message, file_ids).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: fc.ADD_DRAFT_NEWSFEED_REQUEST, data }
  }
  function success(data) {
    return { type: fc.ADD_DRAFT_NEWSFEED_SUCCESS, data }
  }
  function failure(error) {
    return { type: fc.ADD_DRAFT_NEWSFEED_FAILURE, error }
  }
}
function getFeedBlock(feedId) {
  return (dispatch) => {
    dispatch(request({ feedId }))

    feedService.getFeedBlock(feedId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.GET_FEED_BLOCK_REQUEST, response }
  }
  function success(response) {
    return { type: fc.GET_FEED_BLOCK_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.GET_FEED_BLOCK_FAILURE, error }
  }
}
function locatePostInNewsFeed(post_id, newsfeed_id) {
  return (dispatch) => {
    dispatch(request({ post_id, newsfeed_id }))

    feedService.locatePostInNewsFeed(post_id, newsfeed_id).then(
      (response) => {
        dispatch(success({ ...response, post_id, newsfeed_id }))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.LOCATE_POST_IN_NEWSFEED_REQUEST, response }
  }
  function success(response) {
    return { type: fc.LOCATE_POST_IN_NEWSFEED_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.LOCATE_POST_IN_NEWSFEED_FAILURE, error }
  }
}

function createBackgroundTag(
  newsfeedId,
  imagesCount,
  documentsCount,
  originMessageId,
  message,
  taggedGroupIds,
  taggedMixrIds
) {
  const parsedMessage = getParsedMessage(message)
  const taggedUserIds = getTaggedUserIds(parsedMessage)
  const containedLinks = getLinksFromMessage(parsedMessage)
  return (dispatch) => {
    dispatch(request({ newsfeedId, imagesCount, documentsCount, originMessageId }))
    feedService
      .createBackgroundTag(
        newsfeedId,
        imagesCount,
        documentsCount,
        originMessageId,
        message,
        taggedUserIds,
        taggedGroupIds,
        taggedMixrIds,
        containedLinks
      )
      .then(
        (response) => {
          dispatch(commonFeedActions.addDraftNewsFeed(newsfeedId, originMessageId || 0))
          response['draftMessageFeedId'] = originMessageId || 0
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(response) {
    return { type: fc.CREATE_BG_TAG_REQUEST, response }
  }
  function success(response) {
    return { type: fc.CREATE_BG_TAG_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.CREATE_BG_TAG_FAILURE, error }
  }
}

function removeProcessedtag(tag) {
  return { type: fc.REMOVE_PROCESSED_TAG, tag }
}

function getSharingTagFiles(tag) {
  return (dispatch) => {
    dispatch(request({ tag }))
    feedService.getSharingTagFiles(tag).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: fc.GET_SHARING_TAG_FILES_REQUEST, response }
  }
  function success(response) {
    return { type: fc.GET_SHARING_TAG_FILES_SUCCESS, response }
  }
  function failure(error) {
    return { type: fc.GET_SHARING_TAG_FILES_FAILURE, error }
  }
}

function removeSharingProcessedTagFiles() {
  return { type: fc.REMOVE_SHARING_PROCESSED_TAG_FILES }
}
